const conf = {
	// 客户 对 结算方式
	customerPayment2settle: {
		1: {	val: '3', title: '预付全款'	},
		2: {	val: '1', title: '货到付款'	},
		3: {	val: '12', title: '货到3天付款'	},
		12: {	val: '13', title: '货到5天付款'	},
		4: {	val: '5', title: '货到7天付款'	},
		5: {	val: '6', title: '货到15天付款'	},
		6: {	val: '7', title: '货到30天付款'	},
		7: {	val: '8', title: '货到60天付款'	},
		13: {	val: '14', title: '月结1天'	},
		14: {	val: '15', title: '月结5天'	},
		15: {	val: '16', title: '月结15天'	},
		8: {	val: '9', title: '月结30天'	},
		9: {	val: '10', title: '月结45天'	},
		10: {	val: '11', title: '月结60天'	},
		16: {	val: '17', title: '月结60天'	},
		default: {val: '2', title: '预付款+尾款'},// 例： 上海戊禾信息技术有限公司
	},
	// 编辑时允许提交的字段 防止字段过杂影响更新后的东西
	updateAllowField: [
		"id","items","currency","exchange_rate","tax_rate","shippingmethods","isinvoice","amount",
		"settlementtype","amount_subsist","resttime","enclosure","fujian","clientid","company_id",
		"corporation_id","seller","deliverytime","paytype","deliveryplace","attn","payment",
		"add","collection_summary","remark",'ordercode'
	],
	
};

export default conf;
